import _ from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';
import { MultiSelect, MultiSelectOption } from '@ipc/ipc-components';
import { sortRowValues } from '../helpers/sortValues';
import ColumnFilter from './ColumnFilter';

const initialCurrent = {
  valid: false,
};

class NullableBooleanFilter extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      multiSelectOptions: this.getOrderedUniqueValues(props),
    };
  }

  // eslint-disable-next-line camelcase
  UNSAFE_componentWillReceiveProps(nextProps) {
    const { data } = this.props;
    if (!_.isEqual(nextProps.data, data)) {
      this.setState({
        multiSelectOptions: this.getOrderedUniqueValues(nextProps),
      });
    }
  }

  getOrderedUniqueValues = (props) => _(props.data)
    .map((row) => {
      const value = props.column.accessor(row);
      if (value === true) return new MultiSelectOption(true, 'Yes');
      if (value === false) return new MultiSelectOption(false, 'No');
      return new MultiSelectOption(null, '(Blank)');
    })
    .uniqBy('value')
    .value()
    .sort(sortRowValues);

  isValid = (multiSelectValues) => (multiSelectValues && multiSelectValues.length > 0);

  render() {
    const { multiSelectOptions } = this.state;
    return (
      <ColumnFilter
        {...this.props}
        render={(current = initialCurrent, setCurrent) => (
          <div>
            <div className="advanced-filter__fields">
              <MultiSelect
                value={current.multiSelectValues}
                onChange={(value) => setCurrent({
                  ...current,
                  multiSelectValues: value,
                  valid: this.isValid(value),
                })}
                options={multiSelectOptions}
              />
            </div>
          </div>
        )}
      />
    );
  }
}

NullableBooleanFilter.propTypes = {
  data: PropTypes.arrayOf(PropTypes.object),
};

export default NullableBooleanFilter;
